export default "__VITE_ASSET__yWcLaeyt__"